import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { CircleIcon } from '~/Assets/icons'
import { pxToRem } from '~/utils/pxToRem'

import Container from '../../grid/Container/Container'

export default function PageNotFound() {
  const router = useRouter()
  return (
    <Container className="page-not-found">
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        py={['50px', null, '87px']}
        gap={['20px', null, '37px']}
      >
        <Box position="relative">
          <CircleIcon
            position="absolute"
            right="50%"
            bottom={['15px', null, '38px']}
            fontSize={['36px', null, '74px']}
            zIndex="-1"
          />
          <Heading
            fontSize={[pxToRem(90), null, pxToRem(210)]}
            lineHeight="1"
            fontWeight="300"
          >
            404
          </Heading>
        </Box>
        <Text
          fontSize={[pxToRem(30), null, null, pxToRem(48)]}
          fontWeight="300"
          lineHeight="125%"
        >
          We can't find this page.
        </Text>
        <Text
          fontSize={pxToRem(18)}
          fontWeight="300"
          lineHeight={pxToRem(26)}
          maxW="450px"
          sx={{ textWrap: 'balance' }}
        >
          You may have mistyped the address or the page may have moved.
        </Text>
        <Button variant="primary" onClick={() => router.back()}>
          Take me back
        </Button>
      </Flex>
    </Container>
  )
}
